export default function Logo() {
  return (
    <div className='inline-block'>
      <p className='text-white text-2xl font-bold inline-block px-3 items-center align-middle'>
        Portfolio
      </p>
    </div>
  );
}
